import { MessageMedium } from 'modules/graphql';
import { useQueryWhatsAppTemplateLocaleStatuses } from './useQueryWhatsAppTemplateLocaleStatuses';
import { getIsWhatsAppCampaign } from 'modules/campaigns/lib/utils';
import { useSelector } from 'react-redux';
import { selectIsWhatsAppInfobipLocalesEnabled } from 'core/userContext';
import { TemplateType } from 'constants/templateTypes';
import { getTemplateWhatsAppWarnings } from 'modules/templateEditor/integrations/InStudioTemplateEditing/utils';

export interface WhatsAppWarningMessage {
  title: string;
  description: string;
}

export const useWhatsAppWarnings = (
  templateId: number,
  messageMedium: MessageMedium,
  templateType: TemplateType | null,
): WhatsAppWarningMessage[] => {
  const isWhatsAppMedium = getIsWhatsAppCampaign(messageMedium);
  const isBusinessInitiated = templateType === TemplateType.BusinessInitiated;
  const isWhatsAppLocalesFFOn = useSelector(selectIsWhatsAppInfobipLocalesEnabled);
  const isWhatsApp = isWhatsAppMedium && isWhatsAppLocalesFFOn;
  const { results, hasError } = useQueryWhatsAppTemplateLocaleStatuses({
    variables: { id: templateId },
    skip: !isWhatsApp || !isBusinessInitiated,
  });
  const { primaryContent, localeContents } = results.templateAndContent || {};

  if (!isWhatsApp || !isBusinessInitiated || hasError) return [];

  return getTemplateWhatsAppWarnings({ primaryContent, localeContents });
};
